/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable react/no-unused-state */
import { Component } from "react";
import { isNotEmpty, equalsByAttribute, isTouchDevice } from "../../utils";

type OwnProps = {
  allowEmpty?: boolean;
  disabled?: boolean;
  labelKey?: string;
  onChange?: $TSFixMeFunction;
  onSelectChange?: $TSFixMeFunction;
  options?: $TSFixMe[];
  placeholder?: string;
  renderOption?: $TSFixMeFunction;
  renderSelectedValue?: $TSFixMeFunction;
  selectedOption?: $TSFixMe;
  valueKey?: string;
  disableOptionsSort?: boolean;
};

type State = $TSFixMe;

const defaultProps: Partial<OwnProps> = {
  valueKey: "id",
  labelKey: "name",
};

type Props = OwnProps & typeof defaultProps;

class Select extends Component<Props, State> {
  static readonly defaultProps = defaultProps;

  input: $TSFixMe;

  keyboadInputTimer: $TSFixMe;

  selectedOptionRef: $TSFixMe;

  constructor(props: Props) {
    super(props);
    /* istanbul ignore next */
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleInputOnBlur = this.handleInputOnBlur.bind(this);
    this.handleInputOnClick = this.handleInputOnClick.bind(this);
    this.handleInputOnChange = this.handleInputOnChange.bind(this);
    this.handleRenderSelectedOptionOnMouseDown =
      this.handleRenderSelectedOptionOnMouseDown.bind(this);
    this.handleRenderArrowOnMouseDown =
      this.handleRenderArrowOnMouseDown.bind(this);
    this.state = {
      optionsVisible: false,
      selectedOption: null,
      options: null,
      focused: false,
    };
  }

  componentDidMount() {
    this.update(this.props);
  }

  componentDidUpdate(prevProps: Props) {
    const watchedProps = ["options", "selectedOption", "optionsVisible"];
    if (
      watchedProps.find(
        (prop) => !equalsByAttribute(prevProps, this.props, prop),
      )
    ) {
      // watch for changes
      this.update(this.props);
    }
  }

  handleSelection(selectedOption: $TSFixMe, optionVisible = false) {
    // @ts-expect-error TS(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    this.updateInputValue(null);
    this.setState(
      { optionsVisible: optionVisible, selectedOption, focused: false },
      () => {
        this.selectedValueChanged(selectedOption);
      },
    );
  }

  handleChange() {
    const { labelKey } = this.props;
    const { options } = this.state;

    clearTimeout(this.keyboadInputTimer);

    const selectedOption =
      this.input && isNotEmpty(this.input.value)
        ? options.find(
            (o: $TSFixMe) =>
              // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
              o[labelKey]
                .toLowerCase()
                .indexOf(this.input.value.toLowerCase()) === 0,
          )
        : null;

    if (selectedOption) {
      this.setState({
        optionsVisible: true,
        selectedOption,
      });
      setTimeout(() => {
        this.scrollToFocusedOption(true);
      }, 100);
    }

    this.keyboadInputTimer = setTimeout(() => {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
      this.updateInputValue(null);
    }, 800);
  }

  handleInputOnBlur() {
    let optionVisible = false;
    /* istanbul ignore next */
    if (
      document.activeElement &&
      document.activeElement.className === "select-options"
    ) {
      /* istanbul ignore next */
      optionVisible = true;
      /* istanbul ignore next */
      this.input.focus();
    }
    this.handleSelection(this.state.selectedOption, optionVisible);
  }

  handleInputOnChange() {
    this.handleChange();
  }

  handleInputOnClick() {
    const { selectedOption, optionsVisible } = this.state;
    if (!selectedOption) {
      this.setState({ optionsVisible: !optionsVisible });
    }
    this.handleChange();
  }

  handleEnterKey(event: $TSFixMe) {
    if (this.state.optionsVisible) {
      event.preventDefault();
    }
    this.handleSelection(this.state.selectedOption);
  }

  handleEscapeKey() {
    this.setState({
      selectedOption: this.props.selectedOption,
      optionsVisible: false,
    });
    // @ts-expect-error TS(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    this.updateInputValue(null);
  }

  handleKeyDown(event: $TSFixMe) {
    switch (event.keyCode) {
      case 13: // enter
        this.handleEnterKey(event);
        break;
      case 27: // escape
        this.handleEscapeKey();
        break;
      case 38: // up
        this.focusPreviousOption();
        break;
      case 40: // down
        this.focusNextOption();
        break;
      /* istanbul ignore next */
      default:
        /* istanbul ignore next */
        // ignore
        break;
    }
  }

  handleRenderArrowOnMouseDown(event: $TSFixMe) {
    const { disabled } = this.props;
    const { optionsVisible } = this.state;
    if (disabled) {
      return;
    }

    if (optionsVisible) {
      this.setState({ optionsVisible: false });
    } else {
      this.setState({ optionsVisible: true });
    }
    this.input.focus();
    event.preventDefault();
  }

  handleRenderSelectedOptionOnMouseDown(event: $TSFixMe) {
    const { disabled } = this.props;
    const { optionsVisible } = this.state;

    if (disabled) {
      return;
    }
    this.setState({ optionsVisible: !optionsVisible });
    this.input.focus();
    event.preventDefault();
  }

  updateInputValue(value = "") {
    const inputValue = value || "";
    if (this.input && this.input.value !== inputValue) {
      this.input.value = inputValue;
    }
  }

  updateFocusedOptionRef(element: $TSFixMe, focused: $TSFixMe) {
    if (focused) {
      this.selectedOptionRef = element;
    }
  }

  updateInputRef(input: $TSFixMe) {
    this.input = input;
  }

  scrollToFocusedOption(top: $TSFixMe) {
    if (this.selectedOptionRef && this.selectedOptionRef.scrollIntoView) {
      this.selectedOptionRef.scrollIntoView(top);
    }
  }

  update(nextProps: $TSFixMe) {
    const { selectedOption } = this.state;
    const { allowEmpty, labelKey, valueKey, disableOptionsSort } = this.props;

    let relevantOptions = this.state.options;
    let newSelectedOption = this.state.selectedOption;

    let updateState = false;

    if (nextProps.options || this.props.options !== nextProps.options) {
      if (selectedOption) {
        newSelectedOption = this.findOption(selectedOption, nextProps.options);
      }

      const optionsState =
        nextProps.options && isNotEmpty(nextProps.options)
          ? [...nextProps.options]
          : [];

      if (allowEmpty) {
        optionsState.unshift(this.createEmptyOption());
      }

      if (!disableOptionsSort) {
        // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
        optionsState.sort((a, b) => a[labelKey].localeCompare(b[labelKey]));
      }
      relevantOptions = optionsState;
      updateState = true;
    }

    // ¯\_(ツ)_/¯
    const componentShouldUpdate =
      nextProps.selectedOption ||
      !equalsByAttribute(
        this.props.selectedOption,
        nextProps.selectedOption,
        valueKey,
      ) ||
      nextProps.selectedOption === null;

    if (componentShouldUpdate) {
      if (nextProps.options) {
        newSelectedOption = this.findOption(
          nextProps.selectedOption,
          relevantOptions,
        );
      } else {
        newSelectedOption = nextProps.selectedOption;
      }
      updateState = true;
    }

    if (updateState) {
      this.setState({
        selectedOption: newSelectedOption,
        options: relevantOptions,
      });
    }
  }

  createEmptyOption() {
    const { labelKey, valueKey } = this.props;
    const emptyOption = { empty: true };
    // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
    emptyOption[valueKey] = -1;
    // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
    emptyOption[labelKey] = "--";
    return emptyOption;
  }

  selectedValueChanged(value: $TSFixMe) {
    const { onChange } = this.props;
    if (onChange) {
      onChange(!value || value.empty ? null : value);
    }
  }

  focusPreviousOption() {
    const { selectedOption, options } = this.state;
    if (options && selectedOption) {
      const index = options.indexOf(selectedOption);
      if (index > 0) {
        this.setState({
          selectedOption: options[index - 1],
          optionsVisible: true,
        });
      }
      this.scrollToFocusedOption(false);
    }
  }

  focusNextOption() {
    const { selectedOption, options, optionsVisible } = this.state;
    let newSelectedOption = selectedOption;
    if (options) {
      if (optionsVisible) {
        const index = options.indexOf(selectedOption);
        if (index + 1 < options.length) {
          newSelectedOption = options[index + 1];
        }
      }
      this.setState({
        selectedOption: newSelectedOption,
        optionsVisible: true,
      });
      this.scrollToFocusedOption(true);
    }
  }

  findOption(option: $TSFixMe, options: $TSFixMe) {
    const { valueKey } = this.props;
    if (options && option) {
      return (
        // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
        options.find((o: $TSFixMe) => o[valueKey] === option[valueKey]) || null
      );
    }
    return null;
  }

  renderArrow() {
    const { disabled } = this.props;
    const { optionsVisible, options } = this.state;
    const arrowDisabled = disabled || !options || options.length === 0;
    const arrowClassName = arrowDisabled
      ? "select-arrow-disabled"
      : "select-arrow";
    const iconClassName =
      optionsVisible && !arrowDisabled
        ? "icon icon-eh-show-less"
        : "icon icon-eh-show-more";
    return (
      <div
        className={arrowClassName}
        role="button"
        onMouseDown={this.handleRenderArrowOnMouseDown}
      >
        <span className={iconClassName} />
      </div>
    );
  }

  renderOption(option: $TSFixMe) {
    const { renderOption, labelKey } = this.props;
    if (renderOption) {
      return renderOption(option);
    }
    // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
    return <span className="select-option-value">{option[labelKey]}</span>;
  }

  renderSelectedOption() {
    const { disabled, renderSelectedValue } = this.props;
    const { selectedOption } = this.state;

    if (selectedOption && !selectedOption.empty) {
      const className = disabled
        ? "select-option-selected disabled"
        : "select-option-selected";
      return (
        <div
          className={className}
          role="button"
          onMouseDown={this.handleRenderSelectedOptionOnMouseDown}
        >
          {renderSelectedValue
            ? renderSelectedValue(selectedOption)
            : this.renderOption(selectedOption)}
        </div>
      );
    }
    return null;
  }

  renderOptionsOption(option: $TSFixMe, focused: $TSFixMe) {
    const { labelKey } = this.props;
    const { valueKey } = this.props;
    const className = focused
      ? "select-option select-option-focused"
      : "select-option";

    const onClick = (event: $TSFixMe) => {
      this.handleSelection(option);
      event.preventDefault();
    };

    return (
      <div
        role="button"
        // @ts-expect-error TS(2538) FIXME: Type 'undefined' cannot be used as an index type.
        key={option[valueKey]}
        className={className}
        onMouseDown={onClick}
        // @ts-expect-error TS(2322) FIXME: Type '{ children: any; role: "button"; key: any; c... Remove this comment to see the full error message
        summary={option[labelKey]}
        ref={(element) => this.updateFocusedOptionRef(element, focused)}
      >
        {this.renderOption(option)}
      </div>
    );
  }

  renderOptions(options: $TSFixMe) {
    const { selectedOption } = this.state;
    const renderedOptions = options.map((option: $TSFixMe) =>
      this.renderOptionsOption(option, selectedOption === option),
    );
    return (
      <div id="select-options" className="select-options">
        {renderedOptions}
      </div>
    );
  }

  render() {
    const { disabled, placeholder, onSelectChange } = this.props;
    const { optionsVisible, options, selectedOption } = this.state;
    const renderedSelectedOption = this.renderSelectedOption();
    const renderedArrow = this.renderArrow();
    const renderedOptions =
      optionsVisible && options && options.length > 0
        ? this.renderOptions(options)
        : null;
    const renderedPlaceholder =
      selectedOption && !selectedOption.empty ? null : placeholder;

    return (
      <div className="select" role="button" onKeyDown={this.handleKeyDown}>
        {renderedArrow}
        <input
          className="form-control select-input"
          // @ts-expect-error TS(2322) FIXME: Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message
          placeholder={renderedPlaceholder}
          disabled={disabled}
          type="text"
          onFocus={() => this.setState({ focused: true })}
          ref={(input) => this.updateInputRef(input)}
          onBlur={this.handleInputOnBlur}
          onClick={this.handleInputOnClick}
          onChange={onSelectChange || this.handleInputOnChange}
          readOnly={isTouchDevice()}
        />
        {renderedSelectedOption}
        {renderedOptions}
      </div>
    );
  }
}

export default Select;
